import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import cloneDeep from 'lodash/cloneDeep';
import css from './index.scss';
import RadioButton from '../../components/radiobutton/index';
import messages from './messages';

class ExtendResultTable extends Component {
    constructor(props) {
        super(props);
        this.handleOnToggle = this.handleOnToggle.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleSelectorToggle = this.handleSelectorToggle.bind(this);
        this.state = {
            yeargroups: {},
            isSelectorToggled: false,
            isStartFreshChecked: false,
            isKeepResultsChecked: false
        };
    }

    handleOnChange = (yeargroups) => {
        const { yearGroups } = this.props;
        const clonedValue = cloneDeep(yeargroups);
        const { onChange } = this.props;
        onChange(clonedValue);

        const keys = Object.keys(yeargroups);
        const selectedYeargroups = keys.filter(key => yeargroups[key]);
        this.setState({ isStartFreshChecked: selectedYeargroups.length === 0 });
        this.setState({ isKeepResultsChecked: selectedYeargroups.length === yearGroups.length });
    }

    componentWillMount = () => {
        const { yearGroups } = this.props;
        const extendTable = {};
        yearGroups.forEach((item) => {
            extendTable[item.yearGroupEnum] = false;
        });
        this.setState({ yeargroups: extendTable });
        this.handleOnChange(extendTable);
    }

    handleSelectorToggle = (flag) => {
        const clonedState = cloneDeep(this.state.yeargroups);
        Object.keys(clonedState).forEach((v) => { clonedState[v] = flag; });
        this.setState({ yeargroups: clonedState });
        this.handleOnChange(clonedState);
    }

    handleOnToggle = (key) => {
        const newState = { ...this.state.yeargroups };
        newState[key] = !newState[key];
        this.setState({ yeargroups: newState });
        this.handleOnChange(newState);
    }

    render() {
        const { intl, yearGroups } = this.props;
        let items = [];
        if (yearGroups.length > 0) {
            items = yearGroups.map((item) => {
                const yearName = item.longName;
                const yearValue = item.yearGroupEnum;
                const key = `year_${item.shortName}`;
                return (
                    <tr key={yearValue}>
                        <td>{yearName}</td>
                        <td>
                            <RadioButton
                                checked={this.state.yeargroups[yearValue] !== true}
                                name={key}
                                onChange={() => { this.handleOnToggle(yearValue); }} />
                        </td>
                        <td>
                            <RadioButton
                                checked={this.state.yeargroups[yearValue] === true}
                                name={key}
                                onChange={() => { this.handleOnToggle(yearValue); }} />
                        </td>
                    </tr>);
            });
        }
        const tableHeader = yearGroups.length > 0 ? (
            <tr>
                <td>{intl.formatMessage(messages.levelHeader)}</td>
                <td><div>{intl.formatMessage(messages.startFreshHeader)}</div>
                    <RadioButton
                        checked={this.state.isStartFreshChecked}
                        className="start-fresh-toggle"
                        name="mode"
                        onChange={() => { this.handleSelectorToggle(false); }}
                        value="on" />
                </td>
                <td>
                    <div>{intl.formatMessage(messages.keepResultsHeader)}</div>
                    <RadioButton
                        checked={this.state.isKeepResultsChecked}
                        className="keep-result-toggle"
                        name="mode"
                        onChange={() => { this.handleSelectorToggle(true); }}
                        value="off" />
                </td>
            </tr>
        ) : '';
        return (
            <div className={css.extendResultTableContainer}>
                <table className={css.extendResultTable}>
                    <thead>
                        {tableHeader}
                    </thead>
                    <tbody>
                        {items}
                    </tbody>
                </table>
            </div>
        );
    }
}


ExtendResultTable.propTypes = {
    intl: intlShape.isRequired,
    onChange: PropTypes.func,
    yearGroups: PropTypes.arrayOf(PropTypes.object)
};

export default injectIntl(styleable(css)(ExtendResultTable));



// WEBPACK FOOTER //
// ./app/components/extend-result-table/index.js